module.exports = __webpack_public_path__ + "static/media/ams3.a1869455.jpg";